var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicDashboardLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 20,
    fill: "#128BAB",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 22.0955C20.0631 21.503 22.1251 20.8646 24.13 20.6652C26.2917 20.4501 28.1254 20.7663 29.1875 21.8698V37.488C27.6683 36.6386 25.7436 36.522 23.9669 36.6988C22.0488 36.8896 20.1163 37.4377 18.625 37.9984V22.0955ZM30.8125 21.8698C31.8746 20.7663 33.7083 20.4501 35.87 20.6652C37.8749 20.8646 39.9369 21.503 41.375 22.0955V37.9984C39.8837 37.4377 37.9512 36.8896 36.0331 36.6988C34.2564 36.522 32.3317 36.6386 30.8125 37.488V21.8698ZM30 20.4217C28.3995 19.065 26.0786 18.8606 23.9669 19.0707C21.5065 19.3154 19.0225 20.1481 17.4763 20.8412C17.1862 20.9712 17 21.2564 17 21.5706V39.1987C17 39.4712 17.1404 39.7249 17.3726 39.8724C17.6049 40.0199 17.8972 40.0409 18.1487 39.9282C19.5817 39.2858 21.8914 38.5159 24.13 38.2932C26.4179 38.0656 28.3384 38.4331 29.3655 39.6993C29.5197 39.8893 29.7532 40 30 40C30.2468 40 30.4803 39.8893 30.6345 39.6993C31.6616 38.4331 33.5821 38.0656 35.87 38.2932C38.1086 38.5159 40.4183 39.2858 41.8513 39.9282C42.1028 40.0409 42.3951 40.0199 42.6274 39.8724C42.8596 39.7249 43 39.4712 43 39.1987V21.5706C43 21.2564 42.8138 20.9712 42.5237 20.8412C40.9775 20.1481 38.4935 19.3154 36.0331 19.0707C33.9214 18.8606 31.6005 19.065 30 20.4217Z",
    fill: "#128B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicDashboardLink);
export default __webpack_public_path__ + "static/media/academic-dashboard-link.8fc92d9a7367b505e1a847723dd6a564.svg";
export { ForwardRef as ReactComponent };